<template>
  <div class="main">
    <p class="breadcrumb">您的位置：首页 > 项目订单</p>
    <div class="conditions">
      <div class="flexbox cell project" style="align-items: center">
        <div class="flexbox">
          <div class="condleft">选择仓库：</div>
          <el-select
            v-model="project10"
            placeholder="请选择"
            clearable
            filterable
            @change="changeProject"
          >
            <el-option
              v-for="item in projectNameList"
              size="small"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div
        class="flexbox cell"
        v-for="(item, index) in conditionList"
        :key="index"
        :style="{ height: item.height }"
      >
        <div class="condleft">{{ item.typename }}：</div>
        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'ly'">
          <li
            v-for="it in item.typelist"
            :key="it.id"
            :style="{
              color: selcondition.ly == it.id ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.id, item.typeh)"
          >
            {{ it.name }}
          </li>
        </ul>
        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'pp'">
          <li
            v-for="it in item.typelist"
            :key="it.id"
            :style="{
              color: selcondition.pp == it.name ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.name, item.typeh)"
          >
            {{ it.name }}
          </li>
        </ul>

        <ul
          class="flexbox condright"
          :ref="setRef"
          v-if="item.typeh == 'productClass'"
        >
          <li
            v-for="it in item.typelist"
            :key="it.id"
            :style="{
              color:
                selcondition.productClass == it.name
                  ? 'rgb(244,36,52)'
                  : '#000',
            }"
            @click="conditionSelect(it.name, item.typeh, it.id)"
          >
            {{ it.name }}
          </li>
        </ul>

        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'fl'">
          <li
            v-for="it in item.typelist"
            :key="it.id"
            :style="{
              color: selcondition.fl == it.id ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.id, item.typeh)"
          >
            {{ it.name }}
          </li>
        </ul>
        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'bhxs'">
          <li
            v-for="it in item.typelist"
            :key="it.id"
            :style="{
              color: selcondition.bhxs == it.id ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.id, item.typeh)"
          >
            {{ it.name }}
          </li>
        </ul>
        <div
          class="morebtn"
          @click="moreCondition(index)"
          :style="{ height: item.height }"
        >
          {{ item.isMore }}
        </div>
      </div>
      <!-- 下拉框展示 -->
      <div class="flexbox selbox" v-if="false">
        <div class="flexbox selcell">
          <p>领域：</p>
          <el-select
            v-model="selcondition.ly"
            filterable
            placeholder="请选择"
            @change="conditionSelect('ly')"
          >
            <el-option
              v-for="item in conditionList[0].typelist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flexbox selcell">
          <p>品牌：</p>
          <el-select
            v-model="selcondition.pp"
            filterable
            placeholder="请选择"
            @change="conditionSelect('pp')"
          >
            <el-option
              v-for="item in conditionList[1].typelist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flexbox selcell">
          <p>分类：</p>
          <el-select
            v-model="selcondition.fl"
            filterable
            placeholder="请选择"
            @change="conditionSelect('fl')"
          >
            <el-option
              v-for="item in conditionList[2].typelist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flexbox selcell">
          <p>销售类别：</p>
          <el-select
            v-model="selcondition.bhxs"
            filterable
            placeholder="请选择"
            @change="conditionSelect('bhxs')"
          >
            <el-option
              v-for="item in conditionList[3].typelist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      
      <!-- 2021.12.13 库存类型 -->      
      <div class="flexbox kclx">
        <div class="flexbox">
          <p>库存类型：</p>
          <el-select v-model="stockType" placeholder="请选择" @change="hasKc">
            <el-option
              v-for="item in stockTypeList"
              size="small"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <p class="redw">注意：销售类别选择12R时库存类型为必选项。</p>

        </div>
        
        <div class="redw czbtn" @click="clearCondition">重置条件</div>
        
      </div>

    </div>
    <div class="maincon">
      <el-tabs type="card" @tab-click="handleClick">
        <el-tab-pane label="产品列表"></el-tab-pane>
        <el-tab-pane label="添加产品"></el-tab-pane>
      </el-tabs>
      <!-- 产品列表 -->
      <div v-if="tabActive == '0'" class="tabledata">
        <el-button type="primary" style="height: 40px; margin-bottom:20px" @click="addCart1"
          >加入购物车</el-button
        >
        <br>
        <!-- 2021.12.13 品种，规格，形式 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">

          <el-form-item label="品种">
            <el-select
              v-model="project_pz"
              remote
              filterable
              clearable
              placeholder="请选择"
              :remote-method="remoteMethod2"
            >
              <el-option
                v-for="item in popProCon.pzList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="规格">
            <el-input
              v-model="project_gg"
              placeholder=""
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item label="包含形式">
            <el-input
              v-model="project_bhxs"
              placeholder=""
              size="small"
            ></el-input>
          </el-form-item>
          <!-- 2021.12.13 添加查询重置 -->
          <el-form-item>
            <el-button type="primary" @click="getProduct">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getProductDict">重置</el-button>
          </el-form-item>          
        </el-form>

        <!-- <div>我是下拉</div> -->
        <div class="cartcon" v-if="productList.length>0">
          <div class="item">
            <div class="flexbox top">
              <div class="checkbox">
                <el-checkbox v-model="allSelsig" @change="selectAll('sigall')"
                  >全选</el-checkbox
                >
              </div>
              <div class="msg">商品信息</div>
              <!-- <div class="price10">商品编码</div> -->
              <div class="deliver">商品编码</div>
              <div class="stock">库存数量</div>
              
              <div class="price">单价</div>
              <div class="num">数量（个）</div>
              <div class="cases">箱数（箱）</div>
              <div class="weight">重量</div>
              <div class="total">金额</div>
              <div class="operate">操作</div>
            </div>
            <div
              class="flexbox cell"
              v-for="(it, index) in productList"
              :key="index"
            >
              <div class="checkbox">
                <el-checkbox
                  v-model="it.selsig"
                  @change="selectAll('sigorder', it, index)"
                ></el-checkbox>
              </div>
              <div class="flexbox msg">
                <div class="img">
                  <img
                    src="https://online.meide-casting.com/meide/la.img?fn"
                    @click="pageToDetail(it.jppz, it.cz, it.xs)"
                  />
                </div>
                <div class="name">
                  <p>{{ it.name }}</p>
                  <!-- 2021.12.09 -->
                  <!-- <p>{{ it.code }}</p> -->
                  <span>规格:</span>
                  <span class="redw" style="margin-right: 8px">{{
                    it.gg
                  }}</span>
                  <span>表面:</span>
                  <span class="redw" style="margin-right: 8px">{{
                    it.bm
                  }}</span>
                  <span>品种:</span>
                  <span class="redw">{{ it.pz }}</span>
                  <div>
                    <span v-if="it.jq">胶圈:</span>
                    <span v-if="it.jq" class="redw" style="margin-right: 8px">{{
                      it.jq
                    }}</span>
                    <span v-if="it.lslm"> 螺栓螺母:</span>

                    <span
                      v-if="it.lslm"
                      class="redw"
                      style="margin-right: 8px"
                      >{{ it.lslm }}</span
                    >
                    <span>{{ it.stockTypeName }}</span>
                  </div>
                </div>
                <!-- <div class="name"><p>{{ it.code }}</p></div> -->
              </div>
              <div class="deliver"><p style="word-break:break-all">{{ it.code }}</p></div>
              <div class="stock" v-if="it.stockNum>0">{{it.stockNum}}</div>
              <div class="stock" v-else>不足</div>
              
              <div class="price">
                <div class="redw">¥{{ it.facePrice }}</div>
                <!-- <div class="grayw">¥{{ it.hxPrice }}</div> -->
              </div>
              <div class="num">
                <el-input-number 
                  v-model="it.num" 
                  placeholder="0"               
                  @change="
                    numChange1(
                      'jian',
                      it.num,
                      it.caseNum,
                      it.facePrice,
                      it.weight,
                      index,
                      it.stockNum
                    )
                  "
                  :min="0"
                  :controls="false"
                ></el-input-number>  
                <!-- 2021.12.9 --> 
           
                 
                           
                  <!-- :controls="false"
                ></el-input-number> -->
              </div>
              <div class="cases">
                <el-input-number 
                  v-model="it.boxNum"
                  placeholder="0"
                  @change="
                    numChange1(
                      'xiang',
                      it.boxNum,
                      it.caseNum,
                      it.facePrice,
                      it.weight,
                      index,
                      it.stockNum
                    )
                  "
                  :min="0"
                  :controls="false"
                ></el-input-number>
                <!--  -->
              </div>
              <!-- 2021.12.9 重量0 跟价钱算法一样 -->
              <!-- <div class="weight" v-if="it.weight">{{ !it.weight ? 0: it.weight == 'NaN' ? 0 :it.weight }}KG</div> -->
              <div class="weight" v-if="it.totalWeight">{{ !it.totalWeight ? 0: it.totalWeight == 'NaN' ? 0 :it.totalWeight }}KG</div>
              <div class="weight" v-else>{{ 0 }}KG</div>
              <!-- 2021.12.9 金额为0 -->
              <!-- <div class="redw total" v-if="it.totalPrice">¥{{ it.totalPrice }}</div> -->             
              <div class="redw total" v-if="it.totalPrice">¥{{ !it.totalPrice ? 0 : it.totalPrice == 'NaN' ? 0 : it.totalPrice }}</div>
              <div class="redw total" v-else >¥{{ 0 }}</div>
              <div class="operate">
                <i class="el-icon-shopping-cart-2" @click="addCart2(it)"/>
              </div>
            </div>
          </div>
        </div>



             <el-pagination
          v-if="productList.length>0"
          @current-change="getProduct"
          v-model:currentPage="project_start"
          :page-size="100000"
          :total="project_totalNum"
          layout="prev, pager, next, jumper"
          background
        ></el-pagination>
        <!-- <div class="tabledata">
          <el-table
            stripe
            :data="productList"
            max-height="100%"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange1"
          >
            <el-table-column
              type="selection"
              label="选择"
              width="70"
              :selectable="checkSelectable"
            >
            </el-table-column>
        
            <el-table-column
              label="序号"
              type="index"
              width="49"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="code"
              label="客户货号"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="pz"
              label="品种"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="gg"
              label="规格"
              width="80"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="bhxs"
              label="形式"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="cz"
              label="材质"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="bm"
              label="表面处理"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="stockTypeName"
              label="库存类型"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="num"
              label="数量"
              width="85"
              :resizable="false"
            >
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.num"
                  @change="
                    numChange1(
                      'jian',
                      scope.row.num,
                      scope.row.caseNum,
                      scope.row.facePrice,
                      scope.row.weight,
                      scope.$index,
                      scope.row.stockNum
                    )
                  "
                  :min="0"
                  :controls="false"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="boxNum"
              label="箱数"
              width="85"
              :resizable="false"
            >
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.boxNum"
                  @change="
                    numChange1(
                      'xiang',
                      scope.row.boxNum,
                      scope.row.caseNum,
                      scope.row.facePrice,
                      scope.row.weight,
                      scope.$index,
                      scope.row.stockNum
                    )
                  "
                  :min="0"
                  :controls="false"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="stockFlag"
              label="库存状态"
              width="70"
              :resizable="false"
            >
              <template #default="scope">
                <span v-if="scope.row.stockFlag">有</span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="中文货名"
              width="100"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="facePrice"
              label="单价"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="caseNum"
              label="标准箱个数"
              width="88"
              :resizable="false"
            >
            </el-table-column>

            <el-table-column
              prop="tryCaseNum"
              label="每托箱数"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="totalPrice"
              label="金额"
              width="105"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="weight"
              label="重量"
              width="90"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="img"
              label="产品简图"
              width="80"
              :resizable="false"
            >
              <template #default="scope">
                <img :src="scope.row.img" width="30" height="30" />
              </template>
            </el-table-column>
          </el-table>
        </div> -->
      </div>

      <div v-if="tabActive == '1'">
        <div class="flexbox topbtn">
          <!-- <a href="/meide/la.img?fn=EXCEL_MODE" target="_blank" download class="dlbtn"><i class="el-icon-download"></i>下载模板</a> -->
          <a :href="mbUrl" target="_blank" download class="dlbtn"
            ><i class="el-icon-download"></i>下载模板</a
          >
          <el-button type="primary" plain v-if="!doUpload" @click="uploadTips"
            ><i class="el-icon-upload"></i>上传表格</el-button
          >
          <el-upload
            :before-upload="beforeUpload"
            class="upload-demo"
            accept=".xls, .xlsx"
            :action="
              excelupUrl +
              '?pp=' +
              selcondition.pp +
              '&ly=' +
              selcondition.ly +
              '&fl=' +
              selcondition.fl +
              '&bhxs=' +
              selcondition.bhxs +
              '&stockType=' +
              stockType
            "
            :file-list="fileList"
            :show-file-list="false"
            :on-progress="upprogress"
            :on-success="upSuccess"
            v-if="doUpload"
          >
            <el-button type="primary" plain
              ><i class="el-icon-upload"></i>上传表格</el-button
            >
          </el-upload>
          <el-button
            type="primary"
            v-if="mainTableData.length != 0"
            @click="addCart"
            >加入购物车</el-button
          >
          <el-button
            type="primary"
            v-if="mainTableData.length != 0"
            @click="nowBuy"
            >立即购买</el-button
          >
          <el-button v-if="mainTableData.length != 0" @click="delPageGoods"
            >删除</el-button
          >
        </div>
        <div class="tabledata" v-if="mainTableData.length > 0">
          <el-table
            stripe
            :data="mainTableData"
            max-height="100%"
            border
            :summary-method="getSummaries"
            show-summary
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              label="选择"
              width="70"
              :selectable="checkSelectable"
            >
            </el-table-column>
            <!-- 2021.9.23  -->
            <el-table-column
              label="序号"
              type="index"
              width="49"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="customerCode"
              label="客户货号"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="pz"
              label="品种"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="gg"
              label="规格"
              width="80"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="xs"
              label="形式"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="cz"
              label="材质"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="bm"
              label="表面处理"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="stockTypeName"
              label="库存类型"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="num"
              label="数量"
              width="85"
              :resizable="false"
            >
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.num"
                  @change="
                    numChange(
                      'jian',
                      scope.row.num,
                      scope.row.caseNum,
                      scope.row.facePrice,
                      scope.row.weight,
                      scope.$index,
                      scope.row.stockNum
                    )
                  "
                  :min="0"
                  :controls="false"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="boxNum"
              label="箱数"
              width="85"
              :resizable="false"
            >
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.boxNum"
                  @change="
                    numChange(
                      'xiang',
                      scope.row.boxNum,
                      scope.row.caseNum,
                      scope.row.facePrice,
                      scope.row.weight,
                      scope.$index,
                      scope.row.stockNum
                    )
                  "
                  :min="0"
                  :controls="false"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="stockNum"
              label="库存数量"
              width="70"
              :resizable="false"
            >
              <template #default="scope">
                <span v-if="scope.row.stockNum > 0">{{scope.row.stockNum}}</span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="ChinaName"
              label="中文货名"
              width="100"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="facePrice"
              label="单价"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="caseNum"
              label="标准箱个数"
              width="88"
              :resizable="false"
            >
            </el-table-column>
            <!-- 2021.9.22 ~~~~~~~~~~~  -->
            <el-table-column
              prop="tryCaseNum"
              label="每托箱数"
              width="70"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="totalPrice"
              label="金额"
              width="105"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="totalWeight"
              label="重量"
              width="90"
              :resizable="false"
            >
            </el-table-column>
            <el-table-column
              prop="img"
              label="产品简图"
              width="80"
              :resizable="false"
            >
              <template #default="scope">
                <img :src="scope.row.img" width="30" height="30" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class=""></div>
        <div class="addbtn" @click="addpopOpen">
          <i class="el-icon-circle-plus"></i>
          <span>添加商品</span>
        </div>
      </div>
      <!-- 弹窗选择产品 -->
      <div v-dialogdrag>
      <el-dialog
        title="选择产品"
        v-model="dialogTableVisible"
        width="1100px"
        custom-class="addpopbox"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="addpopClose"
      >
        <!-- 下拉框 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="产品编码" style="">
            <el-select
              v-model="formInline.product"
              remote
              filterable
              clearable
              placeholder="请选择"
              :remote-method="remoteMethod"
            >
              <el-option
                v-for="item in popProCon.codeList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="品种">
            <el-select
              v-model="formInline.pz"
              remote
              filterable
              clearable
              placeholder="请选择"
              :remote-method="remoteMethod2"
            >
              <el-option
                v-for="item in popProCon.pzList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="规格">
            <el-input
              v-model="formInline.gg"
              placeholder=""
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item label="形式">
            <el-input
              v-model="formInline.bhxs"
              placeholder=""
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item label="中文货名">
            <el-input
              v-model="formInline.cnName"
              placeholder=""
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="表面处理">
            <el-select
              clearable
              v-model="formInline.bm"
              filterable
              placeholder="请选择"
              remote
              :remote-method="remoteMethod3"
            >
              <el-option
                v-for="item in popProCon.bmList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="客户货号">
            <el-input
              v-model="formInline.customerCode"
              placeholder=""
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="getProList">查询</el-button>
          </el-form-item>
        </el-form>
        <p class="redw">注意：价格或标准箱个数为0的商品无法选择添加</p>
        <el-table
          stripe
          :data="allTabData"
          max-height="400"
          border
          style="width: 90%"
          @selection-change="popSelectionChange"
        >
          <el-table-column type="selection" label="选择" width="30">
          </el-table-column>
          <el-table-column prop="customerCode" label="客户货号" width="90">
          </el-table-column>
          <el-table-column prop="pz" label="品种" width="70"> </el-table-column>
          <el-table-column prop="gg" label="规格" width="110">
          </el-table-column>
          <el-table-column prop="xs" label="形式" width="70"> </el-table-column>
          <el-table-column prop="cz" label="材质" width="70"> </el-table-column>
          <el-table-column prop="bm" label="表面处理" width="70">
          </el-table-column>
          <el-table-column prop="stockTypeName" label="库存类型" width="70">
          </el-table-column>

          <el-table-column prop="ChinaName" label="中文货名" width="120">
          </el-table-column>

          <el-table-column prop="weight" label="单重" width="70">
          </el-table-column>
          <el-table-column prop="img" label="产品简图">
            <template #default="scope">
              <img :src="scope.row.img" width="30" height="30" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          v-model:currentPage="currentPage"
          :page-size="12"
          :total="totalNum"
          layout="prev, pager, next, jumper"
          background
        ></el-pagination>
        <div class="popbtn">
          <el-button type="primary" plain @click="addgoodsToPage"
            >添加</el-button
          >
        </div>
      </el-dialog>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import config from "@/api/config.js";
import { Nummul, Numadd } from "@/util/util.js";
import { ElLoading } from "element-plus";

export default {
  data(){
    return{      
      bhxs:'',
      productClass:'',
      it:{
        num: 0,
        boxNum:0
      },
      
      num:0,
      boxNum:0
      
    }
  },
  name: "GoodsList",
  // 2021.9.23 段明锴 --快速下单，产品列表中增加序号一列，最后增加合计行
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        } else if (
          index === 1 ||
          index === 2 ||
          index === 3 ||
          index === 4 ||
          index === 6 ||
          index === 5 ||
          index === 7 ||
          index === 8 ||
          index === 11 ||
          index === 14 ||
          index === 15 ||
          index === 13 ||
          index === 12 ||
          index === 18
        ) {
          sums[index] = "";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          switch (column.property) {
            case "totalPrice":
              sums[index] = parseFloat(sums[index]).toFixed(2);
              break;
            case "totalWeight":
              sums[index] = parseFloat(sums[index]).toFixed(2);
              break;
          }
        }
      });
      // if(sums = '¥NaN'){
      //   return 0
      // }
      return sums;
      
    },
  },
  components: {},
  setup() {
    let checkSelectable = (row) => {
      return row.caseNum > 0 && row.facePrice > 0;
      //   return row.date == '2016-05-03'
    };

    // 多次调用库存校验
    let tableIdx = ref(0);
    // 2021.12.18 添加调用时候
    let numCheckAn = () => {
      if (tableIdx.value < pageData.mainTableData.length) {
        let data = {
          postType: "queryStockByNum",
          productCode: pageData.mainTableData[tableIdx.value].productCode, // 产品编码
          num: "0", // 产品数量
          stockType: pageData.mainTableData[tableIdx.value].stockType,
          stockName:ystockName.value,
          // stock:ystockId.value?ystockId.value:'10408'
          stock:ystockId.value

        };
        proxy.$axios
          .postNoLoadingReq("/meide/REST/ajaxSelectProduct", data)
          .then((res) => {
            if (res.success == "true") {
              pageData.mainTableData[tableIdx.value].stockNum = res.stockNum;

              if (!res.flag) {
                pageData.mainTableData[tableIdx.value].stockFlag = false;
              } else {
                pageData.mainTableData[tableIdx.value].stockFlag = true;
              }

              tableIdx.value = tableIdx.value + 1;
              numCheckAn();
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  tableIdx.value = tableIdx.value + 1;
                  numCheckAn();
                },
              });
            }
          })
          .catch((error) => {
            tableIdx.value = tableIdx.value + 1;
            numCheckAn();
          });
      } else {
        tableIdx.value = 0;
      }
    };

    // 查询标准箱件数
    let caseNumIdx = ref(0);
    let tryCaseNumIdx = ref(0);
    let caseNumGetAn = () => {
      if (caseNumIdx.value < pageData.mainTableData.length) {
        let data = {
          postType: "queryCaseNum",
          productCode: pageData.mainTableData[caseNumIdx.value].productCode, // 产品编码
          pz: pageData.mainTableData[caseNumIdx.value].pz,
          bm: pageData.mainTableData[caseNumIdx.value].bm,
          gg: pageData.mainTableData[caseNumIdx.value].gg,
          productClass: pageData.mainTableData[caseNumIdx.value].productClass, //?????
          bhxs: pageData.mainTableData[caseNumIdx.value].xs,
          stockType: pageData.mainTableData[caseNumIdx.value].stockType,
          tryCaseNum: pageData.tryCaseNum,
          stockName:ystockName.value,
          stock:ystockId.value

        };
        proxy.$axios
          .postNoLoadingReq("/meide/REST/ajaxSelectProduct", data)
          .then((res) => {
            if (res.success == "true") {
              pageData.mainTableData[caseNumIdx.value].caseNum = res.caseNum;
              caseNumIdx.value = caseNumIdx.value + 1;
              pageData.mainTableData[tryCaseNumIdx.value].tryCaseNum =
                res.tryCaseNum;
              tryCaseNumIdx.value = tryCaseNumIdx.value + 1;
              // console.log(res.tryCaseNum+'wwww')
              caseNumGetAn();
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  caseNumIdx.value = caseNumIdx.value + 1;
                  tryCaseNumIdx.value = tryCaseNumIdx.value + 1;
                  caseNumGetAn();
                },
              });
            }
          })
          .catch((error) => {
            caseNumIdx.value = caseNumIdx.value + 1;
            tryCaseNumIdx.value = tryCaseNumIdx.value + 1;
            caseNumGetAn();
          });
      } else {
        caseNumIdx.value = 0;
        tryCaseNumIdx.value = 0;
      }
    };

    // 查询价格
    let priceIdx = ref(0);
    let priceGetAn = () => {
      if (priceIdx.value < pageData.mainTableData.length) {
        let data = {
          postType: "queryPrice",
          productCode: pageData.mainTableData[priceIdx.value].productCode, // 产品编码
          stockName:ystockName.value,
          stock:ystockId.value
        };
        proxy.$axios
          .postNoLoadingReq("/meide/REST/ajaxSelectProduct", data)
          .then((res) => {
            if (res.success == "true") {
              pageData.mainTableData[priceIdx.value].outFactoryPrice =
                res.outFactoryPrice;
              pageData.mainTableData[priceIdx.value].facePrice = res.facePrice;
              priceIdx.value = priceIdx.value + 1;
              priceGetAn();
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  priceIdx.value = priceIdx.value + 1;
                  priceGetAn();
                },
              });
            }
          })
          .catch((error) => {
            priceIdx.value = priceIdx.value + 1;
            priceGetAn();
          });
      } else {
        priceIdx.value = 0;
      }
    };

    // 左边产品列表查询库存
    let tableIdx1 = ref(0);
    let numCheckAn1 = () => {
      if (tableIdx1.value < productList.value.length) {
        let data = {
          postType: "queryStockByNum",
          productCode: productList.value[tableIdx1.value].code, // 产品编码
          num: "0", // 产品数量
          stockType: productList.value[tableIdx1.value].stockType,
        };
        proxy.$axios
          .postNoLoadingReq("/meide/REST/ajaxSelectProduct", data)
          .then((res) => {
            if (res.success == "true") {
              productList.value[tableIdx1.value].stockNum = res.stockNum;

              if (!res.flag) {
                productList.value[tableIdx1.value].stockFlag = false;
              } else {
                productList.value[tableIdx1.value].stockFlag = true;
              }

              tableIdx1.value = tableIdx1.value + 1;
              numCheckAn1();
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  tableIdx1.value = tableIdx1.value + 1;
                  numCheckAn1();
                },
              });
            }
          })
          .catch((error) => {
            tableIdx1.value = tableIdx1.value + 1;
            numCheckAn1();
          });
      } else {
        tableIdx1.value = 0;
      }
    };
    // 左边产品列表查询标准箱件数
    let caseNumIdx1 = ref(0);
    // let tryCaseNumIdx = ref(0);
    let caseNumGetAn1 = () => {
      if (caseNumIdx1.value < productList.value.length) {
        let data = {
          postType: "queryCaseNum",
          productCode: productList.value[caseNumIdx1.value].code, // 产品编码
          pz: productList.value[caseNumIdx1.value].pz,
          bm: productList.value[caseNumIdx1.value].bm,
          gg: productList.value[caseNumIdx1.value].gg,
          productClass: productList.value[caseNumIdx1.value].proClass, //?????
          bhxs: productList.value[caseNumIdx1.value].bhxs,
          stockType: productList.value[caseNumIdx1.value].stockType,
          // tryCaseNum: pageData.tryCaseNum,
        };
        proxy.$axios
          .postNoLoadingReq("/meide/REST/ajaxSelectProduct", data)
          .then((res) => {
            if (res.success == "true") {
              productList.value[caseNumIdx1.value].caseNum = res.caseNum;
              caseNumIdx1.value = caseNumIdx1.value + 1;
              // pageData.mainTableData[tryCaseNumIdx.value].tryCaseNum =
              //   res.tryCaseNum;
              // tryCaseNumIdx.value = tryCaseNumIdx.value + 1;
              // console.log(res.tryCaseNum+'wwww')
              caseNumGetAn1();
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  caseNumIdx1.value = caseNumIdx1.value + 1;
                  // tryCaseNumIdx.value = tryCaseNumIdx.value + 1;
                  caseNumGetAn1();
                },
              });
            }
          })
          .catch((error) => {
            caseNumIdx1.value = caseNumIdx1.value + 1;
            // tryCaseNumIdx.value = tryCaseNumIdx.value + 1;
            caseNumGetAn1();
          });
      } else {
        caseNumIdx1.value = 0;
        // tryCaseNumIdx.value = 0;
      }
    };
    // 左边的查询价格
    let priceIdx1 = ref(0);
    let priceGetAn1 = () => {
      if (priceIdx1.value < productList.value.length) {
        // console.log(productList.value,222)
        let data = {
          postType: "queryPrice",
          // caseNumIdx1
          productCode: productList.value[priceIdx1.value].code, // 产品编码
        };
        // console.log(caseNumIdx1,2222)
        // console.log(data.productCode,9999)
        proxy.$axios
          .postNoLoadingReq("/meide/REST/ajaxSelectProduct", data)
          .then((res) => {
            if (res.success == "true") {
              productList.value[priceIdx1.value].outFactoryPrice =
              res.outFactoryPrice;
              productList.value[priceIdx1.value].facePrice = res.facePrice;
              priceIdx1.value = priceIdx1.value + 1;
              // console.log(priceIdx1.value,3333)
              priceGetAn1();
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  priceIdx1.value = priceIdx1.value + 1;
                  // console.log(priceIdx1.value,4444)
                  priceGetAn1();
                },
              });
            }
          })
          .catch((error) => {
            priceIdx1.value = priceIdx1.value + 1;
            priceGetAn1();
          });
      } else {
        priceIdx1.value = 0;
      }
    };

    // 左边列表页数量改变-件数、箱数
    let numChange1 = (type, num, chs, price, weight, idx, kcnum) => {
      //  标准箱或者价格为0  阻止  没有库存仍然可以发货
      if (chs == 0 || price == 0) {
        proxy.$alert("商品异常无法购买", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            productList.value[idx].boxNum = 0;
            productList.value[idx].num = 0;
          },
        });
        return;
      }
      if (type == "jian") {
        numCheckNum1(num, kcnum, idx);
        productList.value[idx].boxNum = Math.ceil(num / chs);
        productList.value[idx].totalWeight = (num * weight).toFixed(2);
        // productList.value[idx].totalPrice = Nummul(num, price).toFixed(2);
        productList.value[idx].totalPrice = Nummul(num, price).toFixed(2);
        // console.log(Nummul(num, price).toFixed(2),'jian价钱')
        // console.log((num * weight).toFixed(2),'????')
      } else if (type == "xiang") {
        let jnum = num * chs;

        numCheckNum1(jnum, kcnum, idx);
        productList.value[idx].num = jnum;
        productList.value[idx].totalWeight = (jnum * weight).toFixed(2);
        productList.value[idx].totalPrice = Nummul(jnum, price).toFixed(2);
        // console.log(Nummul(jnum, price).toFixed(2),'xiang,价钱')
        // console.log((jnum * weight).toFixed(2),'xiang， 重量')
      }

      if (productList.value[idx].num > kcnum) {
        productList.value[idx].stockFlag = false;
      } else {
        productList.value[idx].stockFlag = true;
      }
    };

    // 库存校验-比较数量
    let numCheckNum1 = (num, kcnum, idx) => {
      if (num > kcnum) {
        productList.value[idx].stockSign = "N";
      } else {
        productList.value[idx].stockSign = "Y";
      }
    };

    let router = useRouter();
    let { proxy } = getCurrentInstance();
    let store = useStore();
    // 页面数据
    let pageData = reactive({
      stock10:'',
      orderId:'', 
      // 2021.12.14 获取id跟name
      stockId:'',
      stockName10:'',
      // 这里是获取project10的值 2021.12.11
      project10:'',
      stockTypeList10:[],
      stockType11:'',
      stockType10:'',
      bhxs10:'',
      productClass10:'',
      // 页面上的筛选条件
      conditionList: [
        // { typename: '领域', typeh: 'ly', typelist: [], height: '40px', isMore: '更多' },
        // {
        //   typename: "品牌",
        //   typeh: "pp",
        //   typelist: [],
        //   height: "40px",
        //   isMore: "更多",
        // },
        // { typename: '分类', typeh: 'fl', typelist: [], height: '40px', isMore: '更多' },
        {
          typename: "产品",
          typeh: "productClass",
          typelist: [],
          height: "40px",
          isMore: "更多",
        },
        {
          typename: "销售类别",
          typeh: "bhxs",
          typelist: [],
          height: "40px",
          isMore: "更多",
        },
      ],
      // 选择产品时的筛选条件
      formInline: {
        tryCaseNum: "", // 2021.9.23 每拖箱数
        cnName: "", //正文货名
        productCode: "", // 产品编码/长描述/简称（模糊查询）
        pz: "", // 品种（筛选条件）
        gg: "", //规格（筛选条件）
        bm: "", // 表面（筛选条件）
        customerCode: "", //客户编号

        cz: "", // 材质（筛选条件）
        xs: "", // 主形式（筛选条件）

        field: "", // 领域（筛选条件）
        brand: "", // 品牌（筛选条件）
        class: "", // 分类（筛选条件）
        bhxs: "", // 包含形式（筛选条件）
      },
      allTabData: [], // 可选择的产品-弹窗
      // 弹窗添加商品时的筛选条件
      popProCon: {
        codeList: [],
        bmList: [],
        pzList: [],
        xsList: [], //形式
      },
      popSelection: [], // 弹窗中选中的产品
      mainTableData: [], // 页面列表产品
      multipleSelection: [], // 页面上选中的产品
      multipleSelection1: [], // 左边产品上选中的产品
      selidxlist: [], // 选中的产品下标
      selidxall: false, // 是否全选
      cdtCell: [], // 筛选条件展开收起用
      // 筛选条件选择-上传之前必选
      selcondition: {
        pp: "", // 品牌
        ly: "", // 领域
        fl: "", // 分类
        bhxs: "", // 包含形式(销售类别)
      },
      stockType: "", // 库存类型，包含形式为 12R 时必填
      stockTypeList: [], // 库存类型列表
      fileList: [],
      // mbUrl: config.dlbaseURL + '/la.img?fn=G1624952260222F1624952260241.xls', // 模板下载地址
      mbUrl: config.icoBaseUrl + "/static/Template.xls", // 模板下载地址
    });
    // 产品条件展开收起
    let setRef = (el) => {
      pageData.cdtCell.push(el);
    };
    let moreCondition = (idx) => {
      if (pageData.conditionList[idx].isMore == "更多") {
        pageData.conditionList[idx].height =
          pageData.cdtCell[idx].offsetHeight + "px";
        pageData.conditionList[idx].isMore = "收起";
      } else {
        pageData.conditionList[idx].height = "40px";
        pageData.conditionList[idx].isMore = "更多";
      }
    };
    // 查询筛选条件
    let getGoodCondition = (ptype, idx) => {
      let data = {
        postType: ptype,
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxSelectProduct", data)
        .then((res) => {
          if (res.success == "true") {
            pageData.conditionList[idx].typelist = res.data;
            // pageData.conditionList = res.items
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 选择条件
    let doUpload = ref(true);
    let conditionSelect = (id, type, id2) => {
      if (type == "ly") {
        pageData.selcondition.ly = id;
      } else if (type == "pp") {
        pageData.selcondition.pp = id;
      } else if (type == "fl") {
        pageData.selcondition.fl = id;
      } else if (type == "productClass") {
        pageData.conditionList[1].height = "40px";
        pageData.conditionList[1].isMore = "更多";

        pageData.selcondition.productClass = id;
        pageData.bhxs10 = ""

        let data = {
          postType: "queryFastBhxs",
          productClass: id2,
        };
        pageData.productClass10 = data.productClass
        // this.productClass1 = data.productClass.value
        // console.log(data.productClass,1111)
        // console.log(pageData.productClass10,2222)
        proxy.$axios
          .postReq("/meide/REST/ajaxSelectProduct", data)
          .then((res) => {
            // console.log(res,6666)
            if (res.success == "true") {
              pageData.conditionList[1].typelist = res.data;

              // pageData.conditionList = res.items
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {},
              });
            }
          })
          .catch((error) => {
            // proxy.$alert(error, '提示', {
            //     confirmButtonText: '确定',
            //     callback: action => {}
            // });
          });
      } else if (type == "bhxs") {
        pageData.selcondition.bhxs = id;
        getstockTypeList(pageData.selcondition.bhxs);
      }
      // if(pageData.selcondition.pp != '' && pageData.selcondition.ly != '' && pageData.selcondition.fl != '' && pageData.selcondition.bhxs != '')
      if (true) {
        if (pageData.selcondition.bhxs != "12R") {
          doUpload.value = true;
        } else if (
          pageData.selcondition.bhxs == "12R" &&
          pageData.stockType != ""
        ) {
          doUpload.value = true;
        } else {
          doUpload.value = false;
        }
      } else {
        doUpload.value = false;
      }
      //this.getstockTypeList()
    };

    // 2021.12.14 点击事件增加取值
    let hasKc = (vId) => {
      let obj = {}
      obj = pageData.stockTypeList.find((item)=>{
        // console.log(item)
        return item.id === vId
        // console.log(vId)
      })
      // 赋值
      pageData.stockId = obj.id
      pageData.stockName10 = obj.name
      // console.log('你点我？')
      if(obj.name ==='燃气专用件纸箱'){
        pageData.stockType10 = "6"
      }
      if(obj.name =='燃气专用件编织袋'){
        pageData.stockType10 = "7"
      }
      // console.log(pageData.stockType10,333)
      if (
        // pageData.selcondition.pp != "" &&
        // pageData.selcondition.ly != "" &&
        // pageData.selcondition.fl != "" &&
        // pageData.selcondition.bhxs != ""
        true
      ) {
        if (pageData.selcondition.bhxs != "12R") {
          doUpload.value = true;
        } else if (
          pageData.selcondition.bhxs == "12R" &&
          pageData.stockType != ""
        ) {
          doUpload.value = true;
        } else {
          doUpload.value = false;
        }
      } else {
        doUpload.value = false;
      }
    };
    // 重置条件
    let clearCondition = () => {
      for (let key in pageData.selcondition) {
        pageData.selcondition[key] = "";
      }
      pageData.stockType = "";
      doUpload.value = true;
      getGoodCondition("queryFastOrderProductClass", 0); //产品筛选条件列表
      getGoodCondition("queryBhxs", 1); //销售类别筛选条件列表
      // getGoodCondition("queryBrand", 0);
      // // getGoodCondition('queryClass', 2)
      // getGoodCondition("queryFastOrderProductClass", 1);

      // getGoodCondition("queryBhxs", 2);
    };

    // 查询库存条件
    let getstockTypeList = (bhxs) => {
      let data = {
        postType: "getStockType",
        bhxs: bhxs, // 包含形式（筛选条件）
      };
      pageData.bhxs10 = data.bhxs      
      proxy.$axios
        .postReq("/meide/REST/ajaxSelectProduct", data)
        .then((res) => {
          if (res.success == "true") {
            pageData.stockTypeList = res.data;
            pageData.stockTypeList10 = res;  
            // console.log(res.data,111)          
            // pageData.stockType = "";
            //pageData.stockType10 = res.data[0].id
            //pageData.stockType11 = res.data[1].id
            // console.log(res.data[0].id,111,res.data[1].id,222)
            // pageData.stockTypeList = res.data.id
            // console.log(res.data[0],9999)
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };

    // 上传表格
    let shopbtnShow = ref(false);
    let loadingInstance = ref(null);
    let excelupUrl = ref("/meide/REST/ajaxExcelLoad");
    let uploadTips = () => {
      proxy.$alert("上传前请先选择完整的筛选条件", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {},
      });
      return;
    };
    let upprogress = () => {
      ElLoading.service({ fullscreen: true });
      loadingInstance.value = ElLoading.service({ fullscreen: true });
    };
    let upSuccess = (response) => {
      if (response.tip.length > 0) {
        // proxy.$message.error(response.tip || response.ErrorText, "提示", {
        //   confirmButtonText: "确定",
        //   callback: (action) => {},
        // });

        proxy.$alert(response.tip || response.ErrorText, "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      } else {
      }
      if (response.data.length > 0) {
        response.data.map((item) => {
          item.totalWeight = (item.num * item.weight).toFixed(2);
          if (item.num > item.stockNum) {
            item.stockSign = "N";
          } else {
            item.stockSign = "Y";
          }
        });

        pageData.mainTableData = response.data;

        numCheckAn();

        caseNumGetAn();
        priceGetAn();
      }
      loadingInstance.value.close();
    };
    // 选择产品
    let dialogTableVisible = ref(false);
    let handleSelectionChange = (val) => {
      pageData.multipleSelection = val;
    };
    let handleSelectionChange1 = (val) => {
      pageData.multipleSelection1 = val;
    };
    // 数量改变-件数、箱数
    let numChange = (type, num, chs, price, weight, idx, kcnum) => {
      //  标准箱或者价格为0  阻止  没有库存仍然可以发货
      if (chs == 0 || price == 0) {
        proxy.$alert("商品异常无法购买", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            pageData.mainTableData[idx].boxNum = 0;
            pageData.mainTableData[idx].num = 0;
          },
        });
        return;
      }

      if (type == "jian") {
        // numCheck(pageData.mainTableData[idx].productCode, num, idx)
        numCheckNum(num, kcnum, idx);
        pageData.mainTableData[idx].boxNum = Math.ceil(num / chs);
        pageData.mainTableData[idx].totalWeight = (num * weight).toFixed(2);
        pageData.mainTableData[idx].totalPrice = Nummul(num, price).toFixed(2);
      } else if (type == "xiang") {
        let jnum = num * chs;
        // numCheck(pageData.mainTableData[idx].productCode, jnum, idx)
        numCheckNum(jnum, kcnum, idx);
        pageData.mainTableData[idx].num = jnum;
        pageData.mainTableData[idx].totalWeight = (jnum * weight).toFixed(2);
        pageData.mainTableData[idx].totalPrice = Nummul(jnum, price).toFixed(2);
      }

      if (pageData.mainTableData[idx].num > kcnum) {
        pageData.mainTableData[idx].stockFlag = false;
      } else {
        pageData.mainTableData[idx].stockFlag = true;
      }
    };
    // 库存校验-调用接口
    let numCheck = (code, num, idx) => {
      let data = {
        postType: "queryStockByNum",
        productCode: code, // 产品编码
        num: num, // 产品数量
      };

      proxy.$axios
        .postReq("/meide/REST/ajaxSelectProduct", data)
        .then((res) => {
          if (res.success == "true") {
            if (!res.flag) {
              pageData.mainTableData[idx].stockFlag = false;
            } else {
              pageData.mainTableData[idx].stockFlag = true;
            }
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          proxy.$alert(error, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
        });
    };
    // 库存校验-比较数量
    let numCheckNum = (num, kcnum, idx) => {
      if (num > kcnum) {
        pageData.mainTableData[idx].stockSign = "N";
      } else {
        pageData.mainTableData[idx].stockSign = "Y";
      }
    };
    // 加入购物车
    let addCartClick = ref(true);
    let hasstock = ref(true); // 是否全都有充足库存

    //立即购买
    let buyClick = ref(true);        
    let nowBuy = () => {
      if (buyClick) {
        buyClick.value = false;
        let products = [];
        pageData.multipleSelection.map((it) => {
          let ob = {
            tsdId: "", // 购物车子单ID
            code: "", // 产品编码
            num: "", // 数量
            boxNum: "", // 箱数
            packNum: "", // 标准箱件数
            stockType: "", // 库存类型
          };
          if (it.num != 0) {
            ob.tsdId = "";
            ob.code = it.productCode;
            ob.num = it.num;
            ob.boxNum = it.boxNum;
            ob.packNum = it.caseNum;
            ob.stockType = pageData.stockType;
            ob.bhxs = it.xs;
            products.push(ob);
          }          
        });

        let params = { data: [] };
        let ary = [];
        products.map((item) => {
          let flag = false;
          ary.map((item2) => {
            if (item2.bhxs == item.bhxs) {
              item2.products.push(item);
              flag = true;
            }
          });
          if (!flag) {
            ary.push({ bhxs: item.bhxs, products: [item] });
          }
        });
        params.data = ary;

        if (params.data.length == 0) {
          proxy.$alert("未选中任何商品", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              buyClick.value = true;
            },
          });
          return;
        }

        let data = {
          postType: "createOrder",
          type: "3", // 订单类型（1.普通订单 2.项目订单 3.异地仓订单 4.样品订单）
          // ydStock:ystockId.value?ystockId.value:'10408',
          ydStock:ystockId.value,
          // ydStockName:ystockName.value?ystockName.value:'玫德集团成都仓库',
          ydStockName:ystockName.value,
          data: JSON.stringify(params), // 订单信息
          project: project.value,
        };
        proxy.$axios
          .postReq("/meide/REST/ajaxCommitOrder", data)
          .then((res) => {
            if (res.success == "true") {
              ElMessage.success({
                message: res.Info || res.errInfo,
                type: "success",
              });
              buyClick.value = true;

              router.push({
                name: "Settlement",
                params: {
                  id: res.orderNo,
                },
              });
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  buyClick.value = true;
                },
              });
            }
          });
      }
    };
    let addCart = () => {
      if (addCartClick.value) {
        addCartClick.value = false;
        // pageData.multipleSelection.map(item => {
        //     if(item.price == 0) {}
        // })
        if (ystockId.value == "") {
          proxy.$alert("请先选择仓库", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              addCartClick.value = true;
            },
          });
          return;
        }
        let goodsdata = {
          data: [],
        };

        pageData.multipleSelection.map((item) => {
          let ob = {};
          ob.code = item.productCode;
          ob.num = item.num;
          ob.boxNum = item.boxNum;
          ob.packNum = item.caseNum;
          ob.stockType = item.stockType;
          ob.stockSign = item.stockSign;
          ob.stockNum = item.stockNum;
          ob.facePrice = item.facePrice;
          ob.outFactoryPrice = item.outFactoryPrice;
          goodsdata.data.push(ob);
        });
        if (goodsdata.data.length == "0") {
          proxy.$alert("未选中任何商品", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              addCartClick.value = true;
            },
          });
          return;
        }
        for (let a = 0; a < pageData.multipleSelection.length; a++) {
          if (pageData.multipleSelection[a].stockFlag == false) {
            hasstock.value = false;
          }
        }
        if (!hasstock.value) {
          proxy.$alert("商品库存不足时需进行生产，预计发货时间较长", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              let data = {
                postType: "addToShopCar",
                type: "3", // 订单类型（1:普通订单，2:项目订单，3:异地仓订单）
        
                // ystockNo: ystockId.value?ystockId.value:'10408',
                // ystockName:ystockName.value?ystockName.value:'玫德集团成都仓库',
                ystockNo: ystockId.value,
                ystockName:ystockName.value,
                data: JSON.stringify(goodsdata),
              };
              proxy.$axios
                .postReq("/meide/REST/ajaxShopCar", data)
                .then((res) => {
                  if (res.success == "true") {
                    ElMessage.success({
                      message: res.Info || res.errInfo,
                      type: "success",
                    });
                    addCartClick.value = true;
                    setTimeout(() => {
                      store.commit("shopCartRe", true);
                    }, 1000);
                    delPageGoods();
                  } else {
                    proxy.$alert(res.ErrorText || res.errInfo, "提示", {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        addCartClick.value = true;
                      },
                    });
                  }
                })
                .catch((error) => {
                  proxy.$alert(error, "提示", {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      addCartClick.value = true;
                    },
                  });
                });
            },
          });
        } else {
          let data = {
            postType: "addToShopCar",
            type: "3", // 订单类型（1:普通订单，2:项目订单，3:异地仓订单）
          
            // ystockNo: ystockId.value?ystockId.value:'10408',
            // ystockName:ystockName.value?ystockName.value:'玫德集团成都仓库',
            ystockNo: ystockId.value,
            ystockName:ystockName.value,
            data: JSON.stringify(goodsdata),
          };
          proxy.$axios.postReq("/meide/REST/ajaxShopCar", data).then((res) => {
            if (res.success == "true") {
              ElMessage.success({
                message: res.Info || res.errInfo,
                type: "success",
              });
              addCartClick.value = true;
              setTimeout(() => {
                store.commit("shopCartRe", true);
              }, 1000);
              delPageGoods();
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  addCartClick.value = true;
                },
              });
            }
          });
        }
      }
    };


    // 删除页面产品
    let delPageGoods = () => {
      if (pageData.multipleSelection.length == "0" && !pageData.selidxall) {
        proxy.$alert("未选中任何商品", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return;
      } else {
        let arr = [];
        let arr1 = pageData.mainTableData;
        let arr2 = pageData.multipleSelection;
        arr = arr1.filter(function (item) {
          return arr2.indexOf(item) == -1;
        });
        pageData.mainTableData = arr;
      }
    };
    // 可选择产品弹窗-分页
    let currentPage = ref(1);
    let totalNum = ref(0);
    let handleCurrentChange = (val) => {
      currentPage.value = val;
      getProList();
    };
    // 弹窗中选择产品
    let popSelectionChange = (val) => {
      pageData.popSelection = val;
    };
    // 添加选中的产品
    let addgoodsToPage = () => {
      if (pageData.popSelection.length == 0) {
        proxy.$alert("还未选择任何商品", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });

        return;
      }

      pageData.popSelection.map((item) => {
        item.num = 0;
        item.boxNum = 0;
        item.totalWeight = 0;
        item.totalPrice = 0;
      });

      let newArray = [];
      //一下条件相同，将不会从添加窗口填入主数据
      pageData.popSelection.map((item) => {
        let flag = true;
        pageData.mainTableData.map((item2) => {
          if (
            item.pz == item2.pz &&
            item.gg == item2.gg &&
            item.xs == item2.xs &&
            item.cz == item2.cz &&
            item.bm == item2.bm &&
            item.stockType == item2.stockType
          ) {
            flag = false;
          }
        });

        if (flag) {
          newArray.push(item);
        } else {
          flag = true;
        }
      });

      pageData.mainTableData = pageData.mainTableData.concat(
        // pageData.popSelection
        newArray
      );

      numCheckAn();
      caseNumGetAn();
      priceGetAn();
      // dialogTableVisible.value = false
      // for(let key in pageData.formInline) {
      //     pageData.formInline[key] = ''
      // }
      setTimeout(() => {
        addpopClose();
      }, 100);
    };
    // 关闭添加弹窗
    let addpopClose = () => {
      dialogTableVisible.value = false;
      for (let key in pageData.formInline) {
        pageData.formInline[key] = "";
      }
      pageData.allTabData = [];
      pageData.popSelection = [];
      pageData.popProCon.codeList = [];
      pageData.popProCon.bmList = [];
      pageData.popProCon.pzList = [];
    };
    // 打开添加弹窗
    let addpopOpen = () => {
      let p = project.value;
      // console.log(p);
      if (!p) {
        // proxy.$alert("请先选择异地仓订单", "提示", {
        //   confirmButtonText: "确定",
        //   callback: (action) => {},
        // });

        // return;
      }

      dialogTableVisible.value = true;
      getProCon("queryCode", "");
      getProCon("queryPz", "");
      getProCon("queryBm", "");
      getProCon("queryXs", "");

      // }
    };
    // 查询可选择产品
    let getProList = () => {
      let myBhxs;
      if (pageData.formInline.bhxs != "") {
        myBhxs = pageData.formInline.bhxs;
      } else {
        myBhxs = pageData.selcondition.bhxs;
      }
      // 2021.12.14 在外面先定义一个公共的参数
      let params = {
        cnName: pageData.formInline.cnName, //商品中文名（筛选条件）
        productCode: pageData.formInline.productCode, //产品编码（筛选条件）
        pz: pageData.formInline.pz, // 品种（筛选条件）
        gg: pageData.formInline.gg, //规格（筛选条件）
        bm: pageData.formInline.bm, // 表面（筛选条件）
        // bhxs: pageData.formInline.bhxs, // 包含形式（筛选条件）
        bhxs: myBhxs, // 包含形式（筛选条件）
        cstCode: pageData.formInline.customerCode, //客户编号（筛选条件）
        // gg:'规格',
        postType: "queryFastProductList",
        start: currentPage.value, // 起始页，默认1
        limit: "12", // 每页多少条，默认20
        product: pageData.formInline.product, // 产品编码/长描述/简称（模糊查询）
        cz: "", // 材质（筛选条件）
        // xs: pageData.selcondition.bhxs, // 主形式（筛选条件）
        field: pageData.selcondition.ly, // 领域（筛选条件）
        brand: pageData.selcondition.pp, // 品牌（筛选条件）
        pp: pageData.selcondition.pp, // 品牌（筛选条件）
        class: pageData.selcondition.fl, // 分类（筛选条件）
        // 2021.12.14 增加参数
        stockType:pageData.stockId,        
        orderId:pageData.orderId,
        // stock: ystockId.value?ystockId.value:'10408',
        // stockName:ystockName.value?ystockName.value:'玫德集团成都仓库',
        stock: ystockId.value,
        stockName:ystockName.value
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxSelectProduct", params)
        .then((res) => {
          if (res.success == "true") {
            // res.data.map(item => {
            //     item.weight = item.weight.toFixed(3)
            // })
            pageData.allTabData = res.data;
            totalNum.value = parseInt(res.rowcount);
            dialogTableVisible.value = true;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 查询可选择产品的筛选条件-产品编码、表面、品种
    let getProCon = (ptype, param) => {
      let url;
      if (ptype == "queryXs") {
        url = "/meide/REST/ajaxOrderList";
      } else {
        url = "/meide/REST/ajaxSelectProduct";
      }
      let data = {
        postType: ptype,
        param: param,
        brand: pageData.selcondition.pp,
        xs: pageData.selcondition.bhxs,
      };
      proxy.$axios
        .postNoLoadingReq(url, data)
        .then((res) => {
          if (res.success == "true") {
            if (ptype == "queryCode") {
              pageData.popProCon.codeList = res.data;
            } else if (ptype == "queryPz") {
              pageData.popProCon.pzList = res.data;
            } else if (ptype == "queryBm") {
              pageData.popProCon.bmList = res.data;
            } else if (ptype == "queryXs") {
              pageData.popProCon.xsList = res.data;
            }
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    let remoteMethod = (query) => {
      getProCon("queryCode", query);
    };
    let remoteMethod2 = (query) => {
      getProCon("queryPz", query);
    };
    let remoteMethod3 = (query) => {
      getProCon("queryBm", query);
    };
    // 切换tab
    let handleClick = (tab) => {
      tabActive.value = tab.index;
    };
    let tabActive = ref("0");
    onBeforeMount(() => {
      getProjectName(); //项目名称筛选列表
      getGoodCondition("queryFastOrderProductClass", 0); //产品筛选条件列表
      getGoodCondition("queryBhxs", 1); //销售类别筛选条件列表
      // getProjectName(); //项目名称筛选列表
      getProduct() // 项目订单产品列表  选择项目名称的时候才触发
    });
    // 2021.12.13 重置    
    let getProductDict = () => {
      let params = {
        postType: "getProductsByStock",
        // stock: ystockId.value?ystockId.value:'10408',        
        stock: ystockId.value,
        start: project_start.value,
        limit: 100000,
        // 2021.12.08增加参数
        productClass:pageData.productClass10,
        // bhxs:pageData.bhxs10,      
        stockType:pageData.stockType10,        
        // stockType:
        // bhxs:bhxs
        // productClass: pageData.mainTableData[caseNumIdx.value].productClass,
        // bhxs: productList.value[caseNumIdx1.value].bhxs,
        bhxs:pageData.bhxs10,
        id:pageData.orderId,
      }
      // console.log(project.value,2222)
      // console.log(project,1111)   
      proxy.$axios
        .postReq("/meide/REST/ajaxSelectProduct",params )
        .then((res) => {          
          productList.value = res.data;
          project_totalNum.value=res.rowcount
          // console.log(productList.value)          
          // numCheckAn1();
          // caseNumGetAn1();
          priceGetAn1();
        });
    };
    /////////////////////////////////////////////////////////////////
    //项目订单产品列表
    let productList = ref([]);    
     let getProduct = () => {
       // let stock2 = '',
       
      let params = {
        postType: "getProductsByStock",
        // stock: ystockId.value?ystockId.value:ystockId.value,        
        // stock: ystockId.value?ystockId.value:'10408', 
        stock: ystockId.value,
        start: project_start.value,
        limit: 100000,
        // 2021.12.08增加参数
        productClass:pageData.productClass10,
        bhxs:pageData.bhxs10,      
        stockType:pageData.stockType10,
        pz:project_pz.value,
        gg:project_gg.value,
        // 2021.12.18
        //bhxs:project_bhxs.value,            
        // stockType:
        // bhxs:bhxs
        // productClass: pageData.mainTableData[caseNumIdx.value].productClass,
        // bhxs: productList.value[caseNumIdx1.value].bhxs,
        id:pageData.orderId,
      }
      
      // console.log(project,1111)
      // if(ystockId.value){
      //   params = {
      //     postType: "getProductsByStock",
      //     stock: ystockId.value,          
      //     start: project_start.value,
      //     limit: 100000,
      //     // 2021.12.08增加参数
      //     productClass:pageData.productClass10,
      //     bhxs:pageData.bhxs10,      
      //     stockType:pageData.stockType10,    
      //     pz:project_pz.value,
      //     gg:project_gg.value,
      //     // bhxs:project_bhxs.value,
      //     // stockType:
      //     // bhxs:bhxs
      //     // productClass: pageData.mainTableData[caseNumIdx.value].productClass,
      //     // bhxs: productList.value[caseNumIdx1.value].bhxs,
      //     id:pageData.orderId,
      //   }
      //   console.log(params,363636)
      // }else{
      //   params = {
      //     postType: "getProductsByStock",
      //     // stock: pageData.stock10,          
      //     // stock:'10408',
      //     stock:pageData.stock10,
      //     start: project_start.value,
      //     limit: 100000,
      //     // 2021.12.08增加参数
      //     productClass:pageData.productClass10,
      //     bhxs:pageData.bhxs10,      
      //     stockType:pageData.stockType10,
      //     pz:project_pz.value,
      //     gg:project_gg.value,
      //     // bhxs:project_bhxs.value,  
      //     // stockType:
      //     // bhxs:bhxs
      //     // productClass: pageData.mainTableData[caseNumIdx.value].productClass,
      //     // bhxs: productList.value[caseNumIdx1.value].bhxs,
      //     id:pageData.orderId,
      //   }
      // }        
        //  console.log(params,5555)
      proxy.$axios
        .postReq("/meide/REST/ajaxSelectProduct",params )
        .then((res) => {
          // console.log(res,66666)
          productList.value = res.data;
          pageData.orderId = res.orderId      
          project_totalNum.value=res.rowcount
          // console.log(pageData.orderId,'orderID获取？')          
          // numCheckAn1();
          // caseNumGetAn1();
          priceGetAn1();
        });
    };
    let ystockName=ref('')
    let ystockId=ref('')
    //  切换合同号 2021.12.14 
    let changeProject = (val) => {
      let obj = {};
      obj = projectNameList.value.find((item)=>{//这里的userList就是上面遍历的数据源
          return item.id === val;//筛选出匹配数据                              
      });
      // console.log(obj,'切换')
      if(ystockName.value === ''){
        ystockName.value = '玫德集团成都仓库'
      }
      //  console.log(ystockName.value,'变了？？')
      ystockName.value=obj.name
      // if(ystockId.value === ''){
      //   ystockId.value = '10408'
      // }
      ystockId.value=val       
      pageData.orderId=''
      
      getProduct();
    };
    let project = ref(""); //项目id
    //项目名称列表
    let projectNameList = ref([]);
    //获取项目名称列表
    let getProjectName = () => {
      let data = {
        postType: "getStockByUser",
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxSelectProduct", data)
        .then((res) => {
    
          projectNameList.value = res.data;
          // pageData.project10 = res.data[0].name
          pageData.stock10 = res.data[0].id

        });
    };
    let beforeUpload = () => {
      return new Promise((resolve, reject) => {
        let a = pageData.selcondition.bhxs;
        // let p = project.value;
        if (!a) {
          proxy.$message.error("请先选择销售类别");
          return reject();
        }
        // if (!p) {
        //   proxy.$message.error("请先选择异地仓订单");
        //   return reject();
        // }
        proxy
          .$confirm("", {
            title: "将会覆盖目前已选商品,确认继续上传？",
            closeOnClickModal: false,
          })

          //  this.$confirm(
          //    '提示',
          //    {
          //      title: '提示',
          //      message: h('div', null, newDatas),
          //      showCancelButton: true,
          //      confirmButtonText: '确定',
          //      cancelButtonText: '取消',
          //      type: 'warning'
          //    } ).then(() => { })

          .then((_) => {
            return resolve();
          })
          .catch((_) => {
            return reject();
          });
      });
    };
    let addCart1 = () => {
      // console.log(productList.value, allSelsig.value); 
    let list=[]
    productList.value.map(item=>{

        if(item.selsig){
               
          if(item.num && item.num>0){
        list.push(item)
          }
  
        }
     })




      // pageData.multipleSelection.map(item => {
      //     if(item.price == 0) {}
      // })
      let goodsdata = {
        data: [],
      };

      list.map((item) => {
      // pageData.multipleSelection1.map((item) => {


        let ob = {};
        ob.code = item.code;
        ob.num = item.num;
        ob.boxNum = item.boxNum;
        ob.packNum = item.caseNum;
        ob.stockType = item.stockType;
        ob.stockSign = item.stockSign;
        ob.stockNum = item.stockNum;
        ob.facePrice = item.facePrice;
        ob.outFactoryPrice = item.outFactoryPrice;
        goodsdata.data.push(ob);
      });

      if (goodsdata.data.length == "0") {
        proxy.$alert("未选中任何商品", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            addCartClick.value = true;
          },
        });
        return;
      }
      for (let a = 0; a < pageData.multipleSelection1.length; a++) {
        if (pageData.multipleSelection1[a].stockFlag == false) {
          hasstock.value = false;
        }
      }
      if (!hasstock.value) {
        proxy.$alert("商品库存不足时需进行生产，预计发货时间较长", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            let data = {
              postType: "addToShopCar",
              type: "3", // 订单类型（1:普通订单，2:项目订单，3:异地仓订单）
              // ystockNo: ystockId.value?ystockId.value:'10408',
              // ystockName:ystockName.value?ystockName.value:'玫德集团成都仓库',
              ystockNo: ystockId.value,
              ystockName:ystockName.value,
              data: JSON.stringify(goodsdata),
            };
            proxy.$axios
              .postReq("/meide/REST/ajaxShopCar", data)
              .then((res) => {
                if (res.success == "true") {
                  ElMessage.success({
                    message: res.Info || res.errInfo,
                    type: "success",
                  });
                  addCartClick.value = true;
                  setTimeout(() => {
                    store.commit("shopCartRe", true);
                  }, 1000);
                  // delPageGoods();
                } else {
                  proxy.$alert(res.ErrorText || res.errInfo, "提示", {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      addCartClick.value = true;
                    },
                  });
                }
              })
              .catch((error) => {
                proxy.$alert(error, "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    addCartClick.value = true;
                  },
                });
              });
          },
        });
      } else {
        let data = {
          postType: "addToShopCar",
          type: "3", // 订单类型（1:普通订单，2:项目订单，3:异地仓订单）
          // ystockNo: ystockId.value?ystockId.value:'10408',
          // ystockName:ystockName.value?ystockName.value:'玫德集团成都仓库',
          ystockNo: ystockId.value,
          ystockName:ystockName.value,
          data: JSON.stringify(goodsdata),
        };
        proxy.$axios.postReq("/meide/REST/ajaxShopCar", data).then((res) => {
          if (res.success == "true") {
            ElMessage.success({
              message: res.Info || res.errInfo,
              type: "success",
            });
            addCartClick.value = true;
            setTimeout(() => {
              store.commit("shopCartRe", true);
            }, 1000);
            // delPageGoods();
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                addCartClick.value = true;
              },
            });
          }
        });
      }
    };
    let addCart2 = (item) => {
      let goodsdata = {
        data: [],
      }      
      if(item.num && item.num>0){
        let ob = {};
        ob.code = item.code;
        ob.num = item.num;
        ob.boxNum = item.boxNum;
        ob.packNum = item.caseNum;
        ob.stockType = item.stockType;
        ob.stockSign = item.stockSign;
        ob.stockNum = item.stockNum;
        ob.facePrice = item.facePrice;
        ob.outFactoryPrice = item.outFactoryPrice;
        goodsdata.data.push(ob);
      } else {
        proxy.$alert("商品数量不能为0", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            addCartClick.value = true;
          },
        })
        return
      }
      for (let a = 0; a < pageData.multipleSelection1.length; a++) {
        if (pageData.multipleSelection1[a].stockFlag == false) {
          hasstock.value = false;
        }
      }
      if (!hasstock.value) {
        proxy.$alert("商品库存不足时需进行生产，预计发货时间较长", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            let data = {
              postType: "addToShopCar",
              type: "3", // 订单类型（1:普通订单，2:项目订单，3:异地仓订单）
              // ystockNo: ystockId.value?ystockId.value:'10408',
              // ystockName:ystockName.value?ystockName.value:'玫德集团成都仓库',
              ystockNo: ystockId.value,
              ystockName:ystockName.value,
              data: JSON.stringify(goodsdata),
            };
            proxy.$axios
              .postReq("/meide/REST/ajaxShopCar", data)
              .then((res) => {
                if (res.success == "true") {
                  ElMessage.success({
                    message: res.Info || res.errInfo,
                    type: "success",
                  });
                  addCartClick.value = true;
                  setTimeout(() => {
                    store.commit("shopCartRe", true);
                  }, 1000);
                  // delPageGoods();
                } else {
                  proxy.$alert(res.ErrorText || res.errInfo, "提示", {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      addCartClick.value = true;
                    },
                  });
                }
              })
              .catch((error) => {
                proxy.$alert(error, "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    addCartClick.value = true;
                  },
                });
              });
          },
        });
      } else {
        let data = {
          postType: "addToShopCar",
          type: "3", // 订单类型（1:普通订单，2:项目订单，3:异地仓订单）
          // ystockNo: ystockId.value?ystockId.value:'10408',
          // ystockName:ystockName.value?ystockName.value:'玫德集团成都仓库',
          ystockNo: ystockId.value,
          ystockName:ystockName.value,
          data: JSON.stringify(goodsdata),
        };
        proxy.$axios.postReq("/meide/REST/ajaxShopCar", data).then((res) => {
          if (res.success == "true") {
            ElMessage.success({
              message: res.Info || res.errInfo,
              type: "success",
            });
            addCartClick.value = true;
            setTimeout(() => {
              store.commit("shopCartRe", true);
            }, 1000);
            // delPageGoods();
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                addCartClick.value = true;
              },
            });
          }
        });
      }
    };
    let allSelsig = ref(false);
    // 全选操作
    let selectAll = (type, it, idx) => {
  
      if (type == "sigall") {
      // console.log(allSelsig.value,999)
        //当前已经是全选了，要变成全不选
        if (!allSelsig.value) {
        //  console.log(222)

          allSelsig.value = false;
          productList.value.map((item) => {
            item.selsig = false;
          });
        } else {
        //  console.log(111)
          allSelsig.value = true;
          productList.value.map((item) => {
            item.selsig = true;
          });
        }

        // 二级订单全选
        // if (val) {
        //   pageData.cartList[idx].proData.map((item) => {
        //     item.selsig = true;
        //   });
        // } else {
        //   pageData.cartList[idx].proData.map((item) => {
        //     item.selsig = false;
        //     pageData.realSelAll = false;
        //   });
        // }
        // pageData.realSelAll = true; // 总订单
        // pageData.cartList.map((item) => {
        //   item.proData.map((it) => {
        //     if (!it.selsig) {
        //       pageData.realSelAll = false;
        //     }
        //   });
        // });
      } else if (type == "botall") {
        // 总订单全选
        if (val) {
          pageData.cartList.map((item) => {
            item.selall = true;
            item.proData.map((it) => {
              it.selsig = true;
            });
          });
        } else {
          pageData.cartList.map((item) => {
            item.selall = false;
            item.proData.map((it) => {
              it.selsig = false;
            });
          });
        }
      } else if (type == "sigorder") {
        allSelsig.value = true;
        // 单个子单选择
       // console.log(it.selsig)
       
        // if(it.selsig ){

        // }
        productList.value.map((item) => {
          if (!item.selsig) {
            allSelsig.value = false;
          }
        });
        //  productList.value [idx].selall = true; // 二级订单
        // pageData.realSelAll = true; // 总订单
        // productList.value.map((item) => {
        //   item.proData.map((it) => {
        //     if (!it.selsig) {
        //       item.selall = false;
        //       pageData.realSelAll = false;
        //     }
        //   });
        // });
      }
      
    };
    //获取项目订单产品列表的筛选条件 2021.12.13
    let project_cnName=ref('') 
    let project_productCode=ref('')
    let project_pz=ref('')
    let project_gg=ref('')
    let project_bhxs=ref('')
        //总页数
     let project_totalNum    =ref('')
     let project_start =ref(1)

    return {
      addCart1,
      tryCaseNumIdx, // 2021.9.23
      checkSelectable,
      beforeUpload,
      ...toRefs(pageData),
      setRef,
      moreCondition,
      getGoodCondition,
      conditionSelect,
      hasKc,
      shopbtnShow,
      doUpload,
      getstockTypeList,
      clearCondition,
      excelupUrl,
      uploadTips,
      loadingInstance,
      upprogress,
      upSuccess,
      dialogTableVisible,
      handleSelectionChange,
      handleSelectionChange1,
      numChange,
      numCheck,
      numCheckNum,
      getProList,
      currentPage,
      totalNum,
      handleCurrentChange,
      addCartClick,
      hasstock,
      addCart,
      delPageGoods,
      popSelectionChange,
      addgoodsToPage,
      addpopClose,
      addpopOpen,
      getProCon,
      remoteMethod,
      remoteMethod2,
      remoteMethod3,
      nowBuy,
      projectNameList,
      project,
      handleClick,
      tabActive,
      changeProject,
      productList,
      numChange1,
      // numCheckNum1,
      selectAll,
      allSelsig,
            project_totalNum,
      project_start,
      getProduct,
      // 2021.12.13
      getProductDict,
      project_cnName,
      project_productCode,
      project_pz,
      project_gg,
      project_bhxs,
      addCart2
    };
  },
};
</script>

<style scoped lang="scss">
::v-deep.el-table__fixed-right {
  background: white !important;
  box-shadow: none !important;
}
::v-deep.el-table .el-table__header-wrapper {
  width: 122%;
  line-height: 36px;
}
::v-deep.el-table .el-table__footer-wrapper {
  width: 122%;
  line-height: 38px;
  tr {
    height: 36px !important;
  }
}
::v-deep.el-table {
  overflow: auto;
}
::v-deep.el-table .el-table__body-wrapper {
  overflow: visible;
}
::v-deep.el-table::after {
  position: relative !important;
}

.main {
  padding-bottom: 50px;
}
.breadcrumb {
  width: 1200px;
  margin: 10px auto;
  color: #666;
  font-size: 12px;
}
.conditions {
  width: 1200px;
  margin: auto;
  border: 1px solid rgba(223, 223, 223, 1);
  background: #fff;
  // padding: 10px 0;
  .cell {
    border-bottom: 1px solid rgba(223, 223, 223, 1);
    background: rgba(245, 245, 245, 1);
    align-items: flex-start;
    height: 40px;
    overflow: hidden;
    .condleft {
      width: 130px;
      text-align: center;
      // padding-top: 5px;
      line-height: 40px;
      font-size: 12px;
    }
    .condright {
      padding: 0 10px;
      flex-wrap: wrap;
      width: 1070px;
      background: #fff;
      min-height: 40px;
      li {
        margin: 10px;
        font-size: 12px;
        cursor: pointer;
        font-size: #333;
        &:hover {
          color: rgb(244, 36, 52);
        }
      }
      li.active {
        color: rgb(244, 36, 52);
      }
    }
    .morebtn {
      color: rgb(244, 36, 52);
      width: 150px;
      text-align: right;
      height: 40px;
      line-height: 40px;
      background: #fff;
      padding-right: 25px;
      font-size: 12px;
      cursor: pointer;
    }
    &:last-child {
      border: none;
    }
  }
  .selbox {
    padding: 15px 5px;
    justify-content: space-between;
    .selcell {
      margin: 0 10px;
      p {
        font-size: 12px;
      }
    }
  }
  .kclx {
    justify-content: space-between;
    padding: 7px 15px;
    p {
      font-size: 12px;
    }
    .el-select {
      line-height: 30px;
    }
    .redw {
      font-size: 12px;
      margin-left: 25px;
    }
    .czbtn {
      cursor: pointer;
      font-weight: bold;
    }
  }
}
.maincon {
  width: 1200px;
  margin: auto;
  margin-top: 20px;
  .topbtn {
    align-items: flex-start;
    .el-button {
      height: 40px;
    }
    ::v-deep(.el-upload) {
      margin-bottom: 0;
      .el-button {
        margin-right: 15px;
      }
    }
    .dlbtn {
      display: inline-block;
      width: 112px;
      height: 40px;
      line-height: 40px;
      border: 1px solid rgb(244, 36, 52);
      border-radius: 4px;
      color: rgb(244, 36, 52);
      text-align: center;
      margin-right: 10px;
    }
  }
  .tabledata {
    // margin: 15px 0;
    // ::v-deep(.el-input-number) {
    //   width: 50px;
    // }
    // ::v-deep(.el-input-number.is-without-controls .el-input__inner) {
    //   width: 50px;
    //   padding: 0 5px;
    //   height: 30px;
    // }
    // ::v-deep(.el-table .cell) {
    //   text-align: center;
    //   white-space: nowrap;
    //   text-overflow: ellipsis;
    //   overflow: hidden;
    // }
  }
  .addbtn {
    width: 100%;
    padding: 15px 0;
    border: 1px dashed #00906f;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-top: 20px;
    &:hover {
      background: #eee;
    }
    i {
      color: #00906f;
      font-size: 18px;
      margin-right: 10px;
    }
    span {
      color: #00906f;
      font-size: 16px;
    }
  }
  ::v-deep(.el-table th.gutter) {
    display: table-cell !important;
  }
  ::v-deep(.el-pagination) {
    text-align: center;
    margin-top: 20px;
  }
  ::v-deep(.el-pagination.is-background .el-pager li:hover) {
    background: rgba(255, 0, 0, 1);
    color: #fff;
  }
  ::v-deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
    background: rgba(255, 0, 0, 1);
  }
  ::v-deep(.el-table td) {
    padding: 0;
  }
}
.popbtn {
  margin-top: 20px;
  text-align: center;
}
.addpopbox {
  .el-button--primary {
    height: 40px;
    width: 100px;
  }
}
.el-form--inline .el-form-item {
  margin-right: 14px !important;
}

::v-deep .project .el-input--suffix .el-input__inner {
  height: 25px;

  font-size: 12px;
}
// 选择器的小图标
::v-deep .project .el-input__icon {
  line-height: 25px;
  height: 25px;
}
::v-deep .project .el-input__suffix {
  top: -10px !important;
}

//产品列表类似购物车样式
.cartcon {
  .item {
    margin-bottom: 40px;
    h2 {
      p {
        padding: 5px 20px;
        color: #fff;
        background: rgba(244, 36, 52, 1);
        border-radius: 200px;
        font-size: 16px;
      }
      span {
        color: rgba(244, 36, 52, 1);
        margin-left: 30px;
      }
    }
    .top {
      padding: 15px;
      background-color: rgba(250, 250, 250, 1);
      border-top: 2px solid rgba(244, 36, 52, 1);
      margin-top: 10px;
      margin-bottom: 20px;
      div {
        margin: 0 2px;
        text-align: center;
      }
      .checkbox {
        width: 18px;
        height: 18px;
      }
      .msg {
        width: 330px;
      }
      
      .deliver {
        width: 180px;      
      }
      .stock {
        width: 70px;
      }

      .price {
        width: 80px;
      }
      .num {
        width: 130px;
      }
      .cases {
        width: 130px;
      }
      .weight {
        width: 80px;
      }
      .total {
        flex-grow: 1;
        width: 80px;
      }
      .operate {
        width: 30px;
      }
    }
    .cell {
      padding: 0 15px;
      border: 1px solid rgb(235, 235, 235);
      div {
        margin: 0 2px;
      }
      .checkbox {
        width: 18px;
      }
      .msg {
        width: 330px;
        .img {
          padding: 15px;
          img {
            width: 90px;
            height: 90px;
            cursor: pointer;
          }
        }
        .name {
          p {
            margin-bottom: 5px;
          }
          span {
            font-size: 12px;
          }
        }
      }
      .stock {
        width: 70px;
        text-align: center;
      }
      .deliver {
        width: 180px;
        text-align: center;
        
      }
      .price {
        width: 80px;
        text-align: center;
        .redw {
        }
        .grayw {
          font-size: 12px;
          margin-top: 5px;
          text-decoration: line-through;
        }
      }
      .num {
        margin-right: 10px;
      }
      .cases {
      }
      .weight {
        width: 80px;
        text-align: center;
        font-size: 12px;
      }
      .total {
        flex-grow: 1;
        text-align: center;
      }
      .operate {
        width: 30px;
        text-align: center;
        i {
          font-size: 25px;
          cursor: pointer;
        }
      }
    }
  }
}
.flexbox > div {
  flex-shrink: 0;
}
.flexbox .name {
  flex-shrink: 1;
}
.num,
.cases {
  width: 130px;
}
</style>